import React from 'react'
import "./About2.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";

const About2 = () => {
    return (
        <div className='about2-main'>
            <div className="about2-container">
                <div className="about2-top">
                    <div className="about2-head">
                        <span><TfiLayoutLineSolid />Client Notes</span>
                    </div>
                    <div className="about2-title">
                        <span>What the ledger says about us.
                        </span>
                    </div>
                    <div className="about2-p">
                        <p>Illustrative quotes for layout purposes only. Replace with verified client feedback, reviewed against SEBI advertising guidelines, before launch.</p>

                    </div>

                </div>
                <div className="about2-bottom">
                    <div className="a-bottom-grid">


                        <div className="a-bottom-1">
                            <p>"Opened my account in a single visit — no back and forth, no confusion about paperwork."</p>
                        </div>
                        <div className="a-bottom-2">

                            <div className="bottom-2-icon">
                                <span>R</span>
                            </div>
                            <div className="bottom-2-text">
                                <span>
                                    Rohan S.</span>
                                <span1>Client since 2024, Patiala</span1>
                            </div>
                        </div>
                    </div>
                    <div className="a-bottom-grid">


                        <div className="a-bottom-1">
                            <p>""My advisor actually calls before rebalancing anything. That alone changed how I think about my portfolio.""</p>
                        </div>
                        <div className="a-bottom-2">

                            <div className="bottom-2-icon">
                                <span>P</span>
                            </div>
                            <div className="bottom-2-text">
                                <span>
                                    Priya M.</span>
                                <span1>Mutual Funds & SIP client</span1>
                            </div>
                        </div>
                    </div>
                    <div className="a-bottom-grid">


                        <div className="a-bottom-1">
                            <p>""Straightforward IPO guidance without the sales pressure I got elsewhere."
                                
                                "</p>
                        </div>
                        <div className="a-bottom-2">

                            <div className="bottom-2-icon">
                                <span>A</span>
                            </div>
                            <div className="bottom-2-text">
                                <span>
                                    Amanpreet K.</span>
                                <span1>Equity & IPO client</span1>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default About2